export interface SettingsPath {
    category: string;
    subcategory: string;
}
export function getCopilotSettingsPath(): SettingsPath {
    return {
        category: 'copilot',
        subcategory: 'control',
    };
}

export function getCopilotPrioritizeSettingsPath(): SettingsPath {
    return {
        category: 'copilot',
        subcategory: 'prioritize',
    };
}
